function PriceCalculation() {
  const eachPrice = []
  const eachQty = []
  $('li.right_products').each(function (index) {
    var sngle_price = $(this).attr('data-price')
    console.log(sngle_price)
    var QtycountSingle = $(this).attr('data-qty-of-product')
    QtycountSingle = parseFloat(QtycountSingle)
    if (!isNaN(QtycountSingle)) {
      const QtyCount = eachQty.push(QtycountSingle)
    }
    var eachProPrice = parseFloat(sngle_price) * QtycountSingle
    if (!isNaN(eachProPrice)) {
      const count = eachPrice.push(eachProPrice)
    }
  })

  console.log(eachPrice)
  console.log(eachQty)

  let sum = 0

  // Running the for loop
  for (let i = 0; i < eachPrice.length; i++) {
    sum += eachPrice[i]
  }

  console.log('Sum is ' + sum.toFixed(2))
  var TotalCountPrice = sum.toFixed(2)
  $('.total_wrapper p.sub_total span').text('$' + TotalCountPrice)
  $('.total_wrapper p.final_total span.big_text').text('$' + TotalCountPrice)
}

jQuery(document).ready(function () {
  $(document).on('click', '.quiz_btn', function () {
    $('.quiz_banner').css('display', 'none')
    $('.step_wrapper').css('display', 'block')
    $('.step_wrapper .step.step1').addClass('active')

    $('.back_btn').css('display', 'inline-block')
    $('.skip_quiz_btn').css('display', 'inline-block')
  })

  $(document).on('click', '.next_btn_wrapper a.next_btn', function () {
    $(this).parents('.step_wrapper').find('.active').next().addClass('active')
    $(this).parents('.step_wrapper').find('.active').prev().removeClass('active')
  })

  $(document).on('click', '.quiz_header_wrapper .back_btn', function () {
    if ($('.step.step1').hasClass('active') == true) {
      $('.quiz_banner').css('display', 'block')
      $('.step_wrapper').css('display', 'none')
      $('.back_btn').css('display', 'none')
      $('.skip_quiz_btn').css('display', 'none')
      $('.step_wrapper').find('.active').removeClass('active')
    } else {
      $('.step_wrapper').find('.active').prev().addClass('active')
      $('.step_wrapper').find('.active').next().removeClass('active')
    }
  })

  // var buttonPlus  = $(".quantity button.plus");
  // var buttonMinus = $(".quantity button.minus");

  $(document).on('click', '.quantity button.plus', function () {
    console.log('Plus Click')
    var $n = $(this).parent('.quantity').find('input.number')
    $n.val(Number($n.val()) + 1)
    var valueCount = $n.val() + 1
    var number = $(this).parent('.quantity').find('input.number').val()
    $(this).parent().parent().parent().attr('data-qty-of-product', number)
    setTimeout(function () {
      PriceCalculation()
    }, 500)
  })

  $(document).on('click', '.quantity button.minus', function () {
    console.log('Minus Click')
    var $n = $(this).parent('.quantity').find('input.number')
    var amount = Number($n.val())
    if (amount > 1) {
      $n.val(amount - 1)

      var valueCountm = amount - 1
      $(this).parent().parent().parent().attr('data-qty-of-product', valueCountm)

      setTimeout(function () {
        PriceCalculation()
      }, 500)
    }
  })
})

$(document).ready(function () {
  var myarray = []
  var remove_Item = myarray
  $(document).on('click', 'div#step10.active + .next_btn_wrapper a.next_btn', function () {
    $('.custom_input').each(function (index) {
      var GetNumbaer = $(this).find('input:checked').parent().parent().parent().parent().attr('id')

      var getChecked = $(this).find('input:checked').next('label').text()
      console.log(getChecked)
      if (getChecked != '') {
        if (typeof GetNumbaer !== 'undefined') {
          var StepCount = GetNumbaer
        }

        myarray.push(StepCount + '-' + getChecked)
      }
    })
    console.log('-----')
    console.log('Remove arry: ' + remove_Item)
    console.log(myarray)

    console.log('-----')
    var uniqueAns = []
    $.each(myarray, function (i, el) {
      if ($.inArray(el, uniqueAns) === -1) uniqueAns.push(el)
    })
    //var list = uniqueAns.join();
    console.log(uniqueAns)
    var i
    for (i = 0; i < uniqueAns.length; ++i) {
      console.log(uniqueAns[i])
      var GetCon = uniqueAns[i]
      var GetSt = GetCon.split('-')[0]
      // console.log("Get Here: " + GetSt);

      if (GetSt == 'step5') {
        if (
          GetCon.split('-')[1] == 'Very Fair' ||
          GetCon.split('-')[1] == 'Fair' ||
          GetCon.split('-')[1] == 'White Olive' ||
          GetCon.split('-')[1] == 'Olive light brown'
        ) {
          var isTrueskin = true
        } else {
          var isTrueskin = false
        }
      } else if (GetSt == 'step6') {
        if (
          GetCon.split('-')[1] == 'Black' ||
          GetCon.split('-')[1] == 'Brown' ||
          GetCon.split('-')[1] == 'Dark Blonde'
        ) {
          var isTruehair = true
        } else {
          var isTruehair = false
        }
      }

      // if(GetSt == 'step5' || GetSt == 'step6'){
      //   console.log("If step5 and step6: "+ GetCon.split('-')[1]);

      //   if(GetCon.split('-')[1] == 'Very Fair' || GetCon.split('-')[1] == 'Fair' || GetCon.split('-')[1] == 'White Olive' || GetCon.split('-')[1] == 'Olive light brown' && GetCon.split('-')[1] == 'Black' || GetCon.split('-')[1] == 'Brown' || GetCon.split('-')[1] == 'Dirty Blonde'){
      //     console.log("skin tone")

      //       console.log("The Flasher 2.0 Active");
      //       $('li.product-left[data-product="the-flasher"]').addClass('active-product');
      //       $('.left_content h2').text('Congratulations, Your results are here...');
      //       $('.left_content h2 + p').text('We’ve analyzed your answers and created a plan that best supports your hair removal and body care goals!')

      //   }
      //    else{
      //       $('li.product-left.active-product[data-product="the-flasher"]').removeClass('active-product');
      //       $('.left_content h2').text("Unfortunately, The Flasher 2.0 isn't a good match...");
      //       $('.left_content h2 + p').text("Based on your hair and skin tone, the Flasher 2.0 isn't a good fit for you. However, we are in the works on a product that was designed just for you! Please enter your email address and you'll be the first to know about our upcoming product launches:");
      //     }

      // }
      else if (GetSt == 'step3') {
        if (GetCon.split('-')[1] == 'yes' || GetCon.split('-')[1] == 'Yes, but only in certain places') {
          console.log('The Reviver Active')
          $('li.product-left[data-product="the-reviver"]').addClass('active-product')
          $('.left_content h2').text("Unfortunately, The Flasher 2.0 isn't a good match...")
          $('.left_content h2 + p').text(
            "Based on your hair and skin tone, the Flasher 2.0 isn't a good fit for you. However, we are in the works on a product that was designed just for you! Please enter your email address and you'll be the first to know about our upcoming product launches:"
          )
        } else {
          $('li.product-left.active-product[data-product="the-reviver"]').removeClass('active-product')
          $('.left_content h2').text("Unfortunately, The Flasher 2.0 isn't a good match...")
          $('.left_content h2 + p').text(
            "Based on your hair and skin tone, the Flasher 2.0 isn't a good fit for you. However, we are in the works on a product that was designed just for you! Please enter your email address and you'll be the first to know about our upcoming product launches:"
          )
        }
      } else if (GetSt == 'step8') {
        if (
          GetCon.split('-')[1] == 'All day long, bring on the UV Rays!' ||
          GetCon.split('-')[1] == 'Occasionally throughout the day'
        ) {
          console.log('The Glow Up Active')
          $('li.product-left[data-product="the-glow-up"]').addClass('active-product')
          $('.left_content h2').text("Unfortunately, The Flasher 2.0 isn't a good match...")
          $('.left_content h2 + p').text(
            "Based on your hair and skin tone, the Flasher 2.0 isn't a good fit for you. However, we are in the works on a product that was designed just for you! Please enter your email address and you'll be the first to know about our upcoming product launches:"
          )
        } else {
          $('li.product-left.active-product[data-product="the-glow-up"]').removeClass('active-product')
          // $('.left_content h2').text("Unfortunately, The Flasher 2.0 isn't a good match...");
          // $('.left_content h2 + p').text("Based on your hair and skin tone, the Flasher 2.0 isn't a good fit for you. However, we are in the works on a product that was designed just for you! Please enter your email address and you'll be the first to know about our upcoming product launches:");
        }
      } else if (GetSt == 'step9') {
        if (
          GetCon.split('-')[1] == 'Pretty often! It’s part of my normal routine' ||
          GetCon.split('-')[1] == 'Occasionally, but I need to do it more often'
        ) {
          console.log('The Revealer Active')
          $('li.product-left[data-product="the-revealer"]').addClass('active-product')
          $('.left_content h2').text("Unfortunately, The Flasher 2.0 isn't a good match...")
          $('.left_content h2 + p').text(
            "Based on your hair and skin tone, the Flasher 2.0 isn't a good fit for you. However, we are in the works on a product that was designed just for you! Please enter your email address and you'll be the first to know about our upcoming product launches:"
          )
        } else {
          $('li.product-left.active-product[data-product="the-revealer"]').removeClass('active-product')
          $('.left_content h2').text("Unfortunately, The Flasher 2.0 isn't a good match...")
          $('.left_content h2 + p').text(
            "Based on your hair and skin tone, the Flasher 2.0 isn't a good fit for you. However, we are in the works on a product that was designed just for you! Please enter your email address and you'll be the first to know about our upcoming product launches:"
          )
        }
      } else if (GetSt == 'step10') {
        if (GetCon.split('-')[1] == 'Yes, I’ll take all the help I can get!') {
          console.log('The Pro Membership  Active')
          $('li.product-left[data-product="quicker"]').addClass('active-product')
          $('.left_content h2').text("Unfortunately, The Flasher 2.0 isn't a good match...")
          $('.left_content h2 + p').text(
            "Based on your hair and skin tone, the Flasher 2.0 isn't a good fit for you. However, we are in the works on a product that was designed just for you! Please enter your email address and you'll be the first to know about our upcoming product launches:"
          )
        } else {
          $('li.product-left.active-product[data-product="quicker"]').removeClass('active-product')
          // $('.left_content h2').text("Unfortunately, The Flasher 2.0 isn't a good match...");
          // $('.left_content h2 + p').text("Based on your hair and skin tone, the Flasher 2.0 isn't a good fit for you. However, we are in the works on a product that was designed just for you! Please enter your email address and you'll be the first to know about our upcoming product launches:");
        }
      } else {
        //console.log("Else: " +GetCon );
      }
    }

    console.log('Skin options is: ' + isTrueskin)
    console.log('Hair options is: ' + isTruehair)
    if (isTrueskin && isTruehair) {
      console.log('Show Flasher 2.0')
      $('li.product-left[data-product="the-flasher"]').addClass('active-product')
      $('.left_content h2').text('Congratulations, Your results are here...')
      $('.left_content h2 + p').text(
        'We’ve analyzed your answers and created a plan that best supports your hair removal and body care goals!'
      )
    } else {
      console.log('Hide Flasher 2.0')
      $('li.product-left.active-product[data-product="the-flasher"]').removeClass('active-product')
      $('.left_content h2').text("Unfortunately, The Flasher 2.0 isn't a good match...")
      $('.left_content h2 + p').text(
        "Based on your hair and skin tone, the Flasher 2.0 isn't a good fit for you. However, we are in the works on a product that was designed just for you! Please enter your email address and you'll be the first to know about our upcoming product launches:"
      )
    }

    var checkfirst = $('li.product-left.active-product[data-product="the-flasher"]').length
    var checksecond = $('li.product-left.active-product[data-product="the-reviver"]').length
    var checkthird = $('li.product-left.active-product[data-product="the-revealer"]').length
    var checkforth = $('li.product-left.active-product[data-product="the-glow-up"]').length

    if (checkfirst >= 1 && checksecond >= 1 && checkthird >= 1) {
      console.log('Hide Others Show Only noodist kit')
      $('li.product-left[data-product="the-noodist-kit"]').addClass('active-product')

      $('li.product-left.active-product[data-product="the-flasher"]').removeClass('active-product')
      $('li.product-left.active-product[data-product="the-reviver"]').removeClass('active-product')
      $('li.product-left.active-product[data-product="the-revealer"]').removeClass('active-product')

      $('.left_content h2').text('Congratulations, Your results are here...')
      $('.left_content h2 + p').text(
        'We’ve analyzed your answers and created a plan that best supports your hair removal and body care goals!'
      )
    } else {
      $('li.product-left.active-product[data-product="the-noodist-kit"]').removeClass('active-product')
      // $('.left_content h2').text("Unfortunately, The Flasher 2.0 isn't a good match...");
      //$('.left_content h2 + p').text("Based on your hair and skin tone, the Flasher 2.0 isn't a good fit for you. However, we are in the works on a product that was designed just for you! Please enter your email address and you'll be the first to know about our upcoming product launches:");
    }

    if (checkfirst >= 1 && checksecond >= 1 && checkthird >= 1 && checkforth >= 1) {
      console.log('Hide Others Show Only Pro')

      $('li.product-left[data-product="the-noodist-pro-kit"]').addClass('active-product')

      $('li.product-left.active-product[data-product="the-noodist-kit"]').removeClass('active-product')
      $('li.product-left.active-product[data-product="the-flasher"]').removeClass('active-product')
      $('li.product-left.active-product[data-product="the-reviver"]').removeClass('active-product')
      $('li.product-left.active-product[data-product="the-revealer"]').removeClass('active-product')
      $('li.product-left.active-product[data-product="the-glow-up"]').removeClass('active-product')
      $('li.product-left[data-product="the-noodist-pro-kit"]').addClass('active-product')

      $('.left_content h2').text('Congratulations, Your results are here...')
      $('.left_content h2 + p').text(
        'We’ve analyzed your answers and created a plan that best supports your hair removal and body care goals!'
      )
    } else {
      $('li.product-left.active-product[data-product="the-noodist-pro-kit"]').removeClass('active-product')
      // $('.left_content h2').text("Unfortunately, The Flasher 2.0 isn't a good match...");
      // $('.left_content h2 + p').text("Based on your hair and skin tone, the Flasher 2.0 isn't a good fit for you. However, we are in the works on a product that was designed just for you! Please enter your email address and you'll be the first to know about our upcoming product launches:");
    }
  })

  $(document).on('click', '.quiz_header_wrapper a.back_btn', function () {
    console.log(myarray)
    var Clear = myarray.remove()
    console.log('Here: ' + Clear)
  })
})

$(document).ready(function () {
  $(document).on('click', '.product_wrapper ul li a.btn', function () {
    var dataQtycount = $(this).attr('data-count')
    if (dataQtycount == 0) {
      var count = 0
      count++
      $(this).attr('data-count', count)
    } else {
      console.log('this is else')
      var countPlus = parseFloat(dataQtycount) + 1
      $(this).attr('data-count', countPlus)
    }

    var image = $(this).parent().parent().find('.product_img img').attr('src')

    var title = $(this).parent().find('h3').text()
    var price = $(this).parent().find('h3 + p').html()
    var VariantID = $(this).attr('data-variant-id')
    var Sellingplan = $(this).attr('data_selling_plan')
    var variantPrice = $(this).parent().parent().attr('data-price')
    var VariantName = $(this).parent().parent().attr('data-product')
    var AddedProductID = $(this).attr('data-count')

    if (AddedProductID > 1) {
      var finalQtyOFproduct = $(this).attr('data-count')
      $('li#' + VariantName)
        .find('input.quantity__input')
        .val(finalQtyOFproduct)
      $('li#' + VariantName).attr('data-qty-of-product', finalQtyOFproduct)
      var priceUpdate = $('li#' + VariantName).attr('data-price')

      //console.log(parseFloat(priceUpdate)*finalQtyOFproduct)
    } else {
      $('.your_box ul').append(
        '<li class="right_products" id="' +
          VariantName +
          '" data-price="' +
          variantPrice +
          '" data-variant-id="' +
          VariantID +
          '" data-selling_plan="' +
          Sellingplan +
          '"><div class="product_img"><img src="' +
          image +
          '"></div><div class="product_content"><h3>' +
          title +
          '</h3><p>' +
          price +
          '</p><div class="quantity"><button class="minus" fdprocessedid="xg7z0l">-</button><input class="number" type="number" value="1" fdprocessedid="pvop1p"> <button class="plus" fdprocessedid="mkmfqn">+</button></div></div><a href="javascript:void(0)" class="remove_btn"> <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 3.16206C0 2.81278 0.28314 2.52964 0.632411 2.52964H12.0158C12.3651 2.52964 12.6482 2.81278 12.6482 3.16206C12.6482 3.51133 12.3651 3.79447 12.0158 3.79447H0.632411C0.28314 3.79447 0 3.51133 0 3.16206Z" fill="#8F8F8F"/><path fill-rule="evenodd" clip-rule="evenodd" d="M5.05929 1.26482C4.89156 1.26482 4.73071 1.33145 4.61211 1.45005C4.49351 1.56865 4.42688 1.72951 4.42688 1.89723V3.16206C4.42688 3.51133 4.14374 3.79447 3.79447 3.79447C3.4452 3.79447 3.16206 3.51133 3.16206 3.16206V1.89723C3.16206 1.39406 3.36194 0.911487 3.71774 0.555687C4.07354 0.199886 4.55611 0 5.05929 0H7.58893C8.09211 0 8.57468 0.199886 8.93048 0.555687C9.28628 0.911487 9.48617 1.39406 9.48617 1.89723V3.16206C9.48617 3.51133 9.20303 3.79447 8.85376 3.79447C8.50448 3.79447 8.22134 3.51133 8.22134 3.16206V1.89723C8.22134 1.72951 8.15472 1.56865 8.03612 1.45005C7.91752 1.33145 7.75666 1.26482 7.58893 1.26482H5.05929ZM1.89723 2.52964C2.2465 2.52964 2.52964 2.81278 2.52964 3.16206V12.0158C2.52964 12.1835 2.59627 12.3444 2.71487 12.463C2.83347 12.5816 2.99433 12.6482 3.16206 12.6482H9.48617C9.65389 12.6482 9.81475 12.5816 9.93335 12.463C10.0519 12.3444 10.1186 12.1835 10.1186 12.0158V3.16206C10.1186 2.81278 10.4017 2.52964 10.751 2.52964C11.1003 2.52964 11.3834 2.81278 11.3834 3.16206V12.0158C11.3834 12.519 11.1835 13.0016 10.8277 13.3574C10.4719 13.7132 9.98934 13.913 9.48617 13.913H3.16206C2.65888 13.913 2.17631 13.7132 1.82051 13.3574C1.46471 13.0016 1.26482 12.519 1.26482 12.0158V3.16206C1.26482 2.81278 1.54796 2.52964 1.89723 2.52964Z" fill="#8F8F8F"/><path fill-rule="evenodd" clip-rule="evenodd" d="M5.05929 5.6917C5.40856 5.6917 5.6917 5.97484 5.6917 6.32411V10.1186C5.6917 10.4678 5.40856 10.751 5.05929 10.751C4.71002 10.751 4.42688 10.4678 4.42688 10.1186V6.32411C4.42688 5.97484 4.71002 5.6917 5.05929 5.6917Z" fill="#8F8F8F"/><path fill-rule="evenodd" clip-rule="evenodd" d="M7.58893 5.6917C7.9382 5.6917 8.22134 5.97484 8.22134 6.32411V10.1186C8.22134 10.4678 7.9382 10.751 7.58893 10.751C7.23966 10.751 6.95652 10.4678 6.95652 10.1186V6.32411C6.95652 5.97484 7.23966 5.6917 7.58893 5.6917Z" fill="#8F8F8F"/></svg></a></li>'
      )
      var finalQtyOFproduct = $(this).attr('data-count')
      $('li#' + VariantName).attr('data-qty-of-product', finalQtyOFproduct)
    }

    var getAddedCount = $(this).attr('data-count')
    if (getAddedCount >= 1) {
      $(this).addClass('added')
      $(this).text('Added')
    } else {
      $(this).removeClass('added')
      $(this).text('add to cart')
    }

    setTimeout(function () {
      PriceCalculation()
    }, 500)
  })

  $(document).on('click', 'a.remove_btn', function () {
    var GetAttrID = $(this).parent().attr('id')
    $('li.product-left[data-product="' + GetAttrID + '"]')
      .find('.product_content a.btn.added')
      .removeClass('added')
    $('li.product-left[data-product="' + GetAttrID + '"]')
      .find('.product_content a.btn')
      .attr('data-count', '0')
    $('li.product-left[data-product="' + GetAttrID + '"]')
      .find('.product_content a.btn')
      .text('add to cart')
    $(this).parent().remove()

    setTimeout(function () {
      PriceCalculation()
    }, 500)
  })

  $(document).on('click', '.total_wrapper a.add_to_cart_btn', function () {
    var variants = [] // Create an empty array to store variant data

    // Loop through each selected variant and retrieve its information
    $('li.right_products').each(function () {
      var variantId = $(this).attr('data-variant-id') // Get the selected variant ID
      var quantity = $(this).attr('data-qty-of-product') // Replace with the desired quantity
      var SellingID = $(this).attr('data-selling_plan')

      if (SellingID != '') {
        var variant = {
          id: variantId,
          quantity: quantity,
          selling_plan: SellingID,
        }
      } else {
        var variant = {
          id: variantId,
          quantity: quantity,
        }
      }
      // Create an object to store the variant information

      // Add the variant object to the variants array
      variants.push(variant)
    })

    // Send the variants data to the Shopify cart using AJAX
    $.ajax({
      type: 'POST',
      url: '/cart/add.js', // Replace with the actual Shopify cart URL
      data: {
        items: variants,
      },
      dataType: 'json',
      success: function (response) {
        // Optional: You can display a confirmation message or update the cart count in the UI
        console.log('Products added to cart')
        window.location.href = '/checkout'
      },
      error: function (xhr, status, error) {
        // Handle error response, if any
      },
    })
  })
})
